import { render, staticRenderFns } from "./ProTip.vue?vue&type=template&id=3274ab12&scoped=true&"
var script = {}
import style0 from "./ProTip.vue?vue&type=style&index=0&id=3274ab12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3274ab12",
  null
  
)

export default component.exports